import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import logger from '../../utils/logger';

import { constants } from '../modules/promotionalVideo';
import * as api from '../api/promotionalVideo';
import { PromotionalVideoDisplayResponse } from '../../types/promotionalVideo';

export function* getPromotionalVideo() {
  try {
    const response: PromotionalVideoDisplayResponse = yield call(api.getPromotionalVideoDisplay);

    yield put({
      type: constants.PROMOTIONAL_VIDEO_GET.SUCCESS,
      payload: response?.data ?? null,
    });
  } catch (e: any) {
    const errorMessage =
      e?.data?.message || e?.message || 'Erro ao carregar vídeo promocional';

    logger.error('Erro na saga getPromotionalVideo:', e);

    yield put({
      type: constants.PROMOTIONAL_VIDEO_GET.FAILED,
      message: errorMessage,
    });
  }
}

function* watchGetPromotionalVideo() {
  yield takeLatest(constants.PROMOTIONAL_VIDEO_GET.ACTION, getPromotionalVideo);
}

export function* rootSaga() {
  yield all([fork(watchGetPromotionalVideo)]);
}
